import {
  Alert,
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { type GapQuestionThreadEntry } from '../../utils/patientGapAnalysisStore';

const AUTHOR_LABELS = {
  SYSTEM: 'System',
  PATIENT: 'Patient',
  CLINICIAN: 'Clinician',
} as const;

const ENTRY_COLORS: Record<GapQuestionThreadEntry['author'], 'default' | 'primary' | 'success'> = {
  SYSTEM: 'default',
  PATIENT: 'success',
  CLINICIAN: 'primary',
};

interface GapQuestionThreadProps {
  thread?: GapQuestionThreadEntry[];
  emptyText?: string;
}

export const GapQuestionThread = ({
  thread = [],
  emptyText = 'No activity recorded yet.',
}: GapQuestionThreadProps) => {
  if (thread.length === 0) {
    return <Alert severity="info">{emptyText}</Alert>;
  }

  return (
    <Stack spacing={1.5}>
      {thread.map((entry) => (
        <Paper key={entry.id} variant="outlined" sx={{ p: 1.5 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75, flexWrap: 'wrap' }}>
            <Chip label={AUTHOR_LABELS[entry.author]} size="small" color={ENTRY_COLORS[entry.author]} />
            <Typography variant="caption" color="text.secondary">
              {new Date(entry.createdAt).toLocaleString()}
            </Typography>
          </Stack>
          <Box>
            <Typography variant="body2">{entry.content}</Typography>
          </Box>
        </Paper>
      ))}
    </Stack>
  );
};